import React from "react";
import { Alert } from "react-bootstrap";
import { BulletList } from "../ConfirmDialog/BulletList.styles";
import { ImpactPlaceList, ImpactSectionView } from "./extraImpactDialog.viewModel";

function PlaceList({ places }: { places: ImpactPlaceList }) {
  if (!places.grouped) {
    return places.items.length > 0 ? (
      <BulletList>
        {places.items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </BulletList>
    ) : null;
  }
  return (
    <BulletList>
      {places.groups.map((group, index) => (
        <li key={index}>
          <strong>{group.property}</strong>: {group.items.join(", ")}
        </li>
      ))}
    </BulletList>
  );
}

/** Names come from the backend, so they are rendered as React text, never HTML. */
export function ImpactSections({ sections }: { sections: readonly ImpactSectionView[] }) {
  return (
    <>
      {sections.map(section =>
        section.highlighted ? (
          <Alert key={section.key} variant="warning">
            <p>{section.text}</p>
            <PlaceList places={section.places} />
          </Alert>
        ) : (
          <section key={section.key}>
            <p>{section.text}</p>
            <PlaceList places={section.places} />
          </section>
        )
      )}
    </>
  );
}
